export default __webpack_public_path__ + "static/media/logo+name_white.3bac3075.svg";